import {
  initializeAppWhenInitialModeIsBuilder,
  loadDocumentFromWordPress
} from "@/lib/wordpress/load";
import { documentStore } from "@/store/store";
import { pipe } from "fp-ts/function";
import { fold } from "fp-ts/Either";
import { makeWordPressAjaxRequest } from "@/lib/wordpress/ajax";
import * as t from "io-ts";
import { saveToWordPressWithErrorsLoggedToUiStore } from "@/lib/wordpress/save";
import { deleteNode } from "@/lib/tree/tree";

export const loadDocumentFromWordPressToOnboardingPage = async (
  postId: number | undefined
) => {
  if (!postId) {
    return;
  }
  const maybeLoadedData = await loadDocumentFromWordPress(postId);
  initializeAppWhenInitialModeIsBuilder(maybeLoadedData);
  return maybeLoadedData;
};

export function traverseCanvasDocumentAndToggleSectionVisibilityWithCss(
  nodeIds: number[]
) {
  if (!window.Breakdance.canvas || !window.Breakdance.canvas.document) {
    return;
  }
  const canvasDocument = window.Breakdance.canvas.document;

  canvasDocument.querySelectorAll(".bde-section").forEach(element => {
    (element as HTMLElement).style.display = "block";
  });

  if (!nodeIds || nodeIds.length === 0) {
    return;
  }

  // show the specified sections
  nodeIds.forEach((nodeId: number) => {
    const element = canvasDocument.querySelector(`[data-node-id="${nodeId}"]`);
    if (element) {
      (element as HTMLElement).style.display = "none";
    }
  });
}

export async function trashOnboardingPagesWordpress(pageIdsToTrash: number[]) {
  return pipe(
    await makeWordPressAjaxRequest({
      action: "breakdance_onboarding_trash_pages",
      decoder: t.type({ success: t.string }),
      friendlyName: `Trash onboarding pages"`,
      dataToPost: { pageIdsToTrash }
    }),
    fold(
      () => null,
      response => response
    )
  );
}

export async function removeHomepageSectionsWithBreakdance(
  homepageId: number,
  sectionsIdsToRemove: number[]
) {
  if (sectionsIdsToRemove.length === 0) {
    return;
  }

  await loadDocumentFromWordPressToOnboardingPage(homepageId);

  sectionsIdsToRemove.forEach(sectionId => {
    deleteNode(documentStore.document.tree, sectionId);
  });

  return await saveToWordPressWithErrorsLoggedToUiStore();
}
